export const VIRTUAL_TAIL_ANSWER_MIN_COUNT = 12
export const VIRTUAL_DEEP_LINK_WINDOW_RADIUS = 5

export function shouldVirtualizeAnswerTail({
    isActive,
    activeId,
    canDnDInThisQuest,
    tailAnswerCount,
    minCount = VIRTUAL_TAIL_ANSWER_MIN_COUNT,
}) {
    return !!(isActive && !(activeId && canDnDInThisQuest) && tailAnswerCount >= minCount)
}

export function resolveAnswerDeepLinkTarget({ answers, answerId }) {
    if (!Array.isArray(answers) || !answerId) return null

    const normalizedAnswerId = String(answerId)
    const answerIndex = answers.findIndex(answer => String(answer?.id || '') === normalizedAnswerId)
    if (answerIndex < 0) return null

    return {
        answer: answers[answerIndex],
        answerIndex,
        tailIndex: answerIndex - 1,
        isTitle: answerIndex === 0,
    }
}

export function virtualAnswerTargetWindowIds({
    answers,
    answerIndex,
    radius = VIRTUAL_DEEP_LINK_WINDOW_RADIUS,
}) {
    if (!Array.isArray(answers) || !Number.isFinite(answerIndex) || answerIndex < 0) return []

    const normalizedRadius = Math.max(0, Number(radius) || 0)
    const startIndex = Math.max(1, answerIndex - normalizedRadius)
    const endIndex = Math.min(answers.length - 1, answerIndex + normalizedRadius)
    if (endIndex < startIndex) return []

    return answers
        .slice(startIndex, endIndex + 1)
        .map(answer => answer?.id)
        .filter(Boolean)
        .map(id => String(id))
}
